import { Nullable } from '@/shared/types/app.types'
import { NamedPerson } from '@/api/services/common.dto'
import { TextNormalization } from '@/shared/util/text-normalization'

export class EntityComparatorUtils {
    static comparePersonsByName(person1: NamedPerson, person2: NamedPerson): number {
        const surname1Comparison = EntityComparatorUtils.compareStrings(person1.surname1, person2.surname1)
        if (surname1Comparison !== 0) {
            return surname1Comparison
        }
        const surname2Comparison = EntityComparatorUtils.compareStrings(person1.surname2, person2.surname2)
        if (surname2Comparison !== 0) {
            return surname2Comparison
        }
        const nameComparison = EntityComparatorUtils.compareStrings(person1.name, person2.name)
        if (nameComparison !== 0) {
            return nameComparison
        }
        return EntityComparatorUtils.compareStrings(person1.middleName, person2.middleName)
    }

    static compareStrings(s1: Nullable<string>, s2: Nullable<string>): number {
        if (!s1) {
            if (!s2) {
                return 0
            } else {
                return -1
            }
        } else if (!s2) {
            return 1
        }
        return TextNormalization.removeDiacritics(s1).localeCompare(TextNormalization.removeDiacritics(s2))
    }
}
